// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".left-info__container[data-v-6364062c] {\n  border-right: 2px solid #efefef;\n}\n.file-detail__container[data-v-6364062c] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  margin-top: 30px;\n  padding: 10px 20px;\n  background-color: #ffffff;\n}", ""]);
// Exports
module.exports = exports;
